// Definición de las 5 categorías principales de contextos
const CONTEXT_CATEGORIES = [
    {
        id: 'momentos_especiales',
        icon: '🎈',
        expanded: false,
        title: {
            'es-ES': 'Momentos especiales',
            'ca-ES': 'Moments especials',
            'eu-ES': 'Momentu bereziak',
            'gl-ES': 'Momentos especiais',
            'en-GB': 'Special moments'
        }
    },
    {
        id: 'lugares_compras',
        icon: '🛒',
        expanded: false,
        title: {
            'es-ES': 'Lugares de compras',
            'ca-ES': 'Llocs de compres',
            'eu-ES': 'Erosketa tokiak',
            'gl-ES': 'Lugares de compras',
            'en-GB': 'Shopping places'
        }
    },
    {
        id: 'entornos_naturales',
        icon: '🌳',
        expanded: false,
        title: {
            'es-ES': 'Entornos naturales, fauna y mascotas',
            'ca-ES': 'Entorns naturals, fauna i mascotes',
            'eu-ES': 'Ingurune naturalak, fauna eta maskotadegiak',
            'gl-ES': 'Contornos naturais, fauna e mascotas',
            'en-GB': 'Natural environments, fauna and pets'
        }
    },
    {
        id: 'acciones_cotidianas',
        icon: '🏠',
        expanded: false,
        title: {
            'es-ES': 'Acciones cotidianas',
            'ca-ES': 'Accions quotidianes',
            'eu-ES': 'Eguneroko ekintzak',
            'gl-ES': 'Accións cotiás',
            'en-GB': 'Daily activities'
        }
    },
    {
        id: 'lugares_interes',
        icon: '📚',
        expanded: false,
        title: {
            'es-ES': 'Lugares de interés',
            'ca-ES': 'Llocs d\'interès',
            'eu-ES': 'Intereseko lekuak',
            'gl-ES': 'Lugares de interese',
            'en-GB': 'Places of interest'
        }
    }
];

// Definición de los 40 contextos educativos agrupados por categoría
const CONTEXTS = [
    // ==========================================
    // 🎈 MOMENTOS ESPECIALES (7 contextos)
    // ==========================================
    {
        id: 'cumpleanos',
        category: 'momentos_especiales',
        icon: '🎂',
        color: '#FF6B9D',
        title: {
            'es-ES': 'Mi fiesta de cumpleaños',
            'ca-ES': 'La meva festa d\'aniversari',
            'eu-ES': 'Nire urtebetetze festa',
            'gl-ES': 'A miña festa de aniversario',
            'en-GB': 'My birthday party'
        },
        description: {
            'es-ES': 'Celebra con tarta y regalos',
            'ca-ES': 'Celebra amb pastís i regals',
            'eu-ES': 'Ospatu tarta eta opariez',
            'gl-ES': 'Celebra con tarta e regalos',
            'en-GB': 'Celebrate with cake and presents'
        }
    },
    {
        id: 'feria',
        category: 'momentos_especiales',
        icon: '🎡',
        color: '#FFA726',
        title: {
            'es-ES': 'En la feria',
            'ca-ES': 'A la fira',
            'eu-ES': 'Azokan',
            'gl-ES': 'Na feira',
            'en-GB': 'At the fair'
        },
        description: {
            'es-ES': 'Diversión en las atracciones',
            'ca-ES': 'Diversió a les atraccions',
            'eu-ES': 'Dibersioa erakargarrietan',
            'gl-ES': 'Diversión nas atraccións',
            'en-GB': 'Fun at the rides'
        }
    },
    {
        id: 'cine',
        category: 'momentos_especiales',
        icon: '🎬',
        color: '#9C27B0',
        title: {
            'es-ES': 'Vamos al cine',
            'ca-ES': 'Anem al cinema',
            'eu-ES': 'Zinemara goaz',
            'gl-ES': 'Imos ao cine',
            'en-GB': 'Going to the cinema'
        },
        description: {
            'es-ES': 'Palomitas y películas',
            'ca-ES': 'Crispetes i pel·lícules',
            'eu-ES': 'Artoak eta filmak',
            'gl-ES': 'Pipocas e películas',
            'en-GB': 'Popcorn and movies'
        }
    },
    {
        id: 'viaje_abuelos',
        category: 'momentos_especiales',
        icon: '🚗',
        color: '#3F51B5',
        title: {
            'es-ES': 'De viaje con mis abuelos',
            'ca-ES': 'De viatge amb els meus avis',
            'eu-ES': 'Nire aitona-amonekin bidaian',
            'gl-ES': 'De viaxe cos meus avós',
            'en-GB': 'Traveling with my grandparents'
        },
        description: {
            'es-ES': 'Aventuras con los abuelos',
            'ca-ES': 'Aventures amb els avis',
            'eu-ES': 'Aitona-amonekin abenturak',
            'gl-ES': 'Aventuras cos avós',
            'en-GB': 'Adventures with grandparents'
        }
    },
    {
        id: 'circo',
        category: 'momentos_especiales',
        icon: '🎪',
        color: '#AB47BC',
        title: {
            'es-ES': 'En el circo',
            'ca-ES': 'Al circ',
            'eu-ES': 'Zirkoan',
            'gl-ES': 'No circo',
            'en-GB': 'At the circus'
        },
        description: {
            'es-ES': 'Payasos y acróbatas',
            'ca-ES': 'Pallassos i acròbates',
            'eu-ES': 'Pailazo eta akrobatak',
            'gl-ES': 'Pallasas e acróbatas',
            'en-GB': 'Clowns and acrobats'
        }
    },
    {
        id: 'restaurante',
        category: 'momentos_especiales',
        icon: '🍽️',
        color: '#F44336',
        title: {
            'es-ES': 'En el restaurante',
            'ca-ES': 'Al restaurant',
            'eu-ES': 'Jatetxean',
            'gl-ES': 'No restaurante',
            'en-GB': 'At the restaurant'
        },
        description: {
            'es-ES': 'Comida deliciosa',
            'ca-ES': 'Menjar deliciós',
            'eu-ES': 'Janari goxoa',
            'gl-ES': 'Comida deliciosa',
            'en-GB': 'Delicious food'
        }
    },
    {
        id: 'disfraces',
        category: 'momentos_especiales',
        icon: '🎭',
        color: '#FF6F00',
        title: {
            'es-ES': 'Noche de disfraces',
            'ca-ES': 'Nit de disfresses',
            'eu-ES': 'Mozorroen gaua',
            'gl-ES': 'Noite de disfraces',
            'en-GB': 'Costume night'
        },
        description: {
            'es-ES': 'Disfraces y diversión',
            'ca-ES': 'Disfresses i diversió',
            'eu-ES': 'Mozorroak eta dibersioa',
            'gl-ES': 'Disfraces e diversión',
            'en-GB': 'Costumes and fun'
        }
    },

    // ==========================================
    // 🛒 LUGARES DE COMPRAS (3 contextos)
    // ==========================================
    {
        id: 'fruteria',
        category: 'lugares_compras',
        icon: '🍎',
        color: '#66BB6A',
        title: {
            'es-ES': 'En la frutería',
            'ca-ES': 'A la fruiteria',
            'eu-ES': 'Fruta-dendan',
            'gl-ES': 'Na frutaría',
            'en-GB': 'At the fruit shop'
        },
        description: {
            'es-ES': 'Frutas frescas y coloridas',
            'ca-ES': 'Fruites fresques i acolorides',
            'eu-ES': 'Fruta freskoak eta kolortsuak',
            'gl-ES': 'Froitas frescas e coloridas',
            'en-GB': 'Fresh and colorful fruits'
        }
    },
    {
        id: 'supermercado',
        category: 'lugares_compras',
        icon: '🛍️',
        color: '#42A5F5',
        title: {
            'es-ES': 'En el supermercado',
            'ca-ES': 'Al supermercat',
            'eu-ES': 'Supermerkatura',
            'gl-ES': 'No supermercado',
            'en-GB': 'At the supermarket'
        },
        description: {
            'es-ES': 'Compras de la semana',
            'ca-ES': 'Compres de la setmana',
            'eu-ES': 'Asteko erosketak',
            'gl-ES': 'Compras da semana',
            'en-GB': 'Weekly shopping'
        }
    },
    {
        id: 'centro_comercial',
        category: 'lugares_compras',
        icon: '🏬',
        color: '#26A69A',
        title: {
            'es-ES': 'En el centro comercial',
            'ca-ES': 'Al centre comercial',
            'eu-ES': 'Merkataritza-gunean',
            'gl-ES': 'No centro comercial',
            'en-GB': 'At the shopping mall'
        },
        description: {
            'es-ES': 'Tiendas y diversión',
            'ca-ES': 'Botigues i diversió',
            'eu-ES': 'Dendak eta dibersioa',
            'gl-ES': 'Tendas e diversión',
            'en-GB': 'Stores and fun'
        }
    },

    // ==========================================
    // 🌳 ENTORNOS NATURALES, FAUNA Y MASCOTAS (10 contextos)
    // ==========================================
    {
        id: 'granja',
        category: 'entornos_naturales',
        icon: '🚜',
        color: '#8D6E63',
        title: {
            'es-ES': 'En una granja',
            'ca-ES': 'A una granja',
            'eu-ES': 'Baserri batean',
            'gl-ES': 'Nunha granxa',
            'en-GB': 'At a farm'
        },
        description: {
            'es-ES': 'Animales de granja',
            'ca-ES': 'Animals de granja',
            'eu-ES': 'Baserri animaliak',
            'gl-ES': 'Animais de granxa',
            'en-GB': 'Farm animals'
        }
    },
    {
        id: 'huerto',
        category: 'entornos_naturales',
        icon: '🥕',
        color: '#9CCC65',
        title: {
            'es-ES': 'En el huerto',
            'ca-ES': 'A l\'hort',
            'eu-ES': 'Baratzean',
            'gl-ES': 'Na horta',
            'en-GB': 'In the garden'
        },
        description: {
            'es-ES': 'Verduras y hortalizas',
            'ca-ES': 'Verdures i hortalisses',
            'eu-ES': 'Barazkiak eta landareak',
            'gl-ES': 'Verduras e hortalizas',
            'en-GB': 'Vegetables and greens'
        }
    },
    {
        id: 'parque',
        category: 'entornos_naturales',
        icon: '🌲',
        color: '#7CB342',
        title: {
            'es-ES': 'En el parque',
            'ca-ES': 'Al parc',
            'eu-ES': 'Parkean',
            'gl-ES': 'No parque',
            'en-GB': 'At the park'
        },
        description: {
            'es-ES': 'Columpios y tobogán',
            'ca-ES': 'Balancins i tobogan',
            'eu-ES': 'Kulunkak eta irristaila',
            'gl-ES': 'Balanceos e tobogán',
            'en-GB': 'Swings and slide'
        }
    },
    {
        id: 'playa',
        category: 'entornos_naturales',
        icon: '🏖️',
        color: '#26C6DA',
        title: {
            'es-ES': 'En la playa',
            'ca-ES': 'A la platja',
            'eu-ES': 'Hondartzan',
            'gl-ES': 'Na praia',
            'en-GB': 'At the beach'
        },
        description: {
            'es-ES': 'Arena y olas',
            'ca-ES': 'Sorra i ones',
            'eu-ES': 'Harea eta olatu',
            'gl-ES': 'Area e ondas',
            'en-GB': 'Sand and waves'
        }
    },
    {
        id: 'centro_animales',
        category: 'entornos_naturales',
        icon: '🦜',
        color: '#4CAF50',
        title: {
            'es-ES': 'En el centro de recuperación de animales',
            'ca-ES': 'Al centre de recuperació d\'animals',
            'eu-ES': 'Animaliak berreskuratzeko zentroan',
            'gl-ES': 'No centro de recuperación de animais',
            'en-GB': 'At the animal recovery center'
        },
        description: {
            'es-ES': 'Ayudando a los animales',
            'ca-ES': 'Ajudant als animals',
            'eu-ES': 'Animaliei laguntzen',
            'gl-ES': 'Axudando aos animais',
            'en-GB': 'Helping animals'
        }
    },
    {
        id: 'concurso_canino',
        category: 'entornos_naturales',
        icon: '🐕',
        color: '#FF9800',
        title: {
            'es-ES': 'En el concurso canino',
            'ca-ES': 'Al concurs caní',
            'eu-ES': 'Txakur lehiaketan',
            'gl-ES': 'No concurso canino',
            'en-GB': 'At the dog show'
        },
        description: {
            'es-ES': 'Perros increíbles',
            'ca-ES': 'Gossos increïbles',
            'eu-ES': 'Txakur harrigarriak',
            'gl-ES': 'Cans incríbeis',
            'en-GB': 'Amazing dogs'
        }
    },
    {
        id: 'exposicion_plantas',
        category: 'entornos_naturales',
        icon: '🌺',
        color: '#E91E63',
        title: {
            'es-ES': 'En la exposición de plantas y flores',
            'ca-ES': 'A l\'exposició de plantes i flors',
            'eu-ES': 'Landare eta loreen erakusketan',
            'gl-ES': 'Na exposición de plantas e flores',
            'en-GB': 'At the plant and flower exhibition'
        },
        description: {
            'es-ES': 'Flores hermosas',
            'ca-ES': 'Flors boniques',
            'eu-ES': 'Lore ederrak',
            'gl-ES': 'Flores fermosas',
            'en-GB': 'Beautiful flowers'
        }
    },
    {
        id: 'acuario',
        category: 'entornos_naturales',
        icon: '🐠',
        color: '#29B6F6',
        title: {
            'es-ES': 'En el acuario',
            'ca-ES': 'A l\'aquari',
            'eu-ES': 'Akuarioan',
            'gl-ES': 'No acuario',
            'en-GB': 'At the aquarium'
        },
        description: {
            'es-ES': 'Peces de colores',
            'ca-ES': 'Peixos de colors',
            'eu-ES': 'Arraina koloretsuak',
            'gl-ES': 'Peixes de cores',
            'en-GB': 'Colorful fish'
        }
    },
    {
        id: 'excursion_monte',
        category: 'entornos_naturales',
        icon: '⛰️',
        color: '#795548',
        title: {
            'es-ES': 'De excursión por el monte',
            'ca-ES': 'D\'excursió per la muntanya',
            'eu-ES': 'Mendian txangoan',
            'gl-ES': 'De excursión polo monte',
            'en-GB': 'Hiking in the mountains'
        },
        description: {
            'es-ES': 'Explorando la naturaleza',
            'ca-ES': 'Explorant la naturalesa',
            'eu-ES': 'Natura esploratzen',
            'gl-ES': 'Explorando a natureza',
            'en-GB': 'Exploring nature'
        }
    },
    {
        id: 'mascotas',
        category: 'entornos_naturales',
        icon: '🐾',
        color: '#FF6B9D',
        title: {
            'es-ES': 'Con mis mascotas',
            'ca-ES': 'Amb les meves mascotes',
            'eu-ES': 'Nire maskotaekin',
            'gl-ES': 'Coas miñas mascotas',
            'en-GB': 'With my pets'
        },
        description: {
            'es-ES': 'Cuidando a mis amigos',
            'ca-ES': 'Cuidant als meus amics',
            'eu-ES': 'Nire lagunak zainduz',
            'gl-ES': 'Coidando aos meus amigos',
            'en-GB': 'Caring for my friends'
        }
    },

    // ==========================================
    // 🏠 ACCIONES COTIDIANAS (6 contextos)
    // ==========================================
    {
        id: 'cocina',
        category: 'acciones_cotidianas',
        icon: '👨‍🍳',
        color: '#FFA726',
        title: {
            'es-ES': 'En la cocina',
            'ca-ES': 'A la cuina',
            'eu-ES': 'Sukaldean',
            'gl-ES': 'Na cociña',
            'en-GB': 'In the kitchen'
        },
        description: {
            'es-ES': 'Cocinando recetas',
            'ca-ES': 'Cuinant receptes',
            'eu-ES': 'Errezetak egiten',
            'gl-ES': 'Cociñando receitas',
            'en-GB': 'Cooking recipes'
        }
    },
    {
        id: 'juguetes',
        category: 'acciones_cotidianas',
        icon: '🧸',
        color: '#EC407A',
        title: {
            'es-ES': 'Con mis juguetes',
            'ca-ES': 'Amb les meves joguines',
            'eu-ES': 'Nire jostailuekin',
            'gl-ES': 'Coas miñas xoguetes',
            'en-GB': 'With my toys'
        },
        description: {
            'es-ES': 'Juegos y diversión',
            'ca-ES': 'Jocs i diversió',
            'eu-ES': 'Jolasak eta dibertsioa',
            'gl-ES': 'Xogos e diversión',
            'en-GB': 'Games and fun'
        }
    },
    {
        id: 'deporte',
        category: 'acciones_cotidianas',
        icon: '⚽',
        color: '#FF7043',
        title: {
            'es-ES': 'Practicando deporte',
            'ca-ES': 'Practicant esport',
            'eu-ES': 'Kirola praktikatzen',
            'gl-ES': 'Practicando deporte',
            'en-GB': 'Playing sports'
        },
        description: {
            'es-ES': 'Fútbol y juegos',
            'ca-ES': 'Futbol i jocs',
            'eu-ES': 'Futbola eta jokoak',
            'gl-ES': 'Fútbol e xogos',
            'en-GB': 'Soccer and games'
        }
    },
    {
        id: 'ordenando_cuarto',
        category: 'acciones_cotidianas',
        icon: '🧹',
        color: '#7E57C2',
        title: {
            'es-ES': 'Ordenando mi cuarto',
            'ca-ES': 'Ordenant la meva habitació',
            'eu-ES': 'Nire gela antolatzen',
            'gl-ES': 'Ordenando o meu cuarto',
            'en-GB': 'Tidying my room'
        },
        description: {
            'es-ES': 'Organizando todo',
            'ca-ES': 'Organitzant tot',
            'eu-ES': 'Dena antolatzen',
            'gl-ES': 'Organizando todo',
            'en-GB': 'Organizing everything'
        }
    },
    {
        id: 'manualidades',
        category: 'acciones_cotidianas',
        icon: '✂️',
        color: '#EF5350',
        title: {
            'es-ES': 'Haciendo manualidades',
            'ca-ES': 'Fent manualitats',
            'eu-ES': 'Eskualdiak egiten',
            'gl-ES': 'Facendo manualidades',
            'en-GB': 'Doing crafts'
        },
        description: {
            'es-ES': 'Creando arte',
            'ca-ES': 'Creant art',
            'eu-ES': 'Artea sortzen',
            'gl-ES': 'Creando arte',
            'en-GB': 'Creating art'
        }
    },
    {
        id: 'cromos',
        category: 'acciones_cotidianas',
        icon: '🃏',
        color: '#FBC02D',
        title: {
            'es-ES': 'Mi colección de cromos',
            'ca-ES': 'La meva col·lecció de cromos',
            'eu-ES': 'Nire kromo bilduma',
            'gl-ES': 'A miña colección de cromos',
            'en-GB': 'My sticker collection'
        },
        description: {
            'es-ES': 'Organizando cromos',
            'ca-ES': 'Organitzant cromos',
            'eu-ES': 'Kromoak antolatzen',
            'gl-ES': 'Organizando cromos',
            'en-GB': 'Organizing stickers'
        }
    },

    // ==========================================
    // 📚 LUGARES DE INTERÉS (9 contextos)
    // ==========================================
    {
        id: 'biblioteca',
        category: 'lugares_interes',
        icon: '📖',
        color: '#5C6BC0',
        title: {
            'es-ES': 'En la biblioteca',
            'ca-ES': 'A la biblioteca',
            'eu-ES': 'Liburutegian',
            'gl-ES': 'Na biblioteca',
            'en-GB': 'At the library'
        },
        description: {
            'es-ES': 'Leyendo cuentos',
            'ca-ES': 'Llegint contes',
            'eu-ES': 'Ipuinak irakurtzen',
            'gl-ES': 'Lendo contos',
            'en-GB': 'Reading stories'
        }
    },
    {
        id: 'patio_colegio',
        category: 'lugares_interes',
        icon: '🏫',
        color: '#FFB74D',
        title: {
            'es-ES': 'En el patio del colegio',
            'ca-ES': 'Al pati de l\'escola',
            'eu-ES': 'Eskolako patioan',
            'gl-ES': 'No patio do colexio',
            'en-GB': 'In the school playground'
        },
        description: {
            'es-ES': 'Jugando con amigos',
            'ca-ES': 'Jugant amb amics',
            'eu-ES': 'Lagunekin jolasten',
            'gl-ES': 'Xogando con amigos',
            'en-GB': 'Playing with friends'
        }
    },
    {
        id: 'museo',
        category: 'lugares_interes',
        icon: '🦴',
        color: '#8D6E63',
        title: {
            'es-ES': 'En el museo de ciencias naturales',
            'ca-ES': 'Al museu de ciències naturals',
            'eu-ES': 'Natur zientzien museoan',
            'gl-ES': 'No museo de ciencias naturais',
            'en-GB': 'At the natural science museum'
        },
        description: {
            'es-ES': 'Descubriendo dinosaurios',
            'ca-ES': 'Descobrint dinosaures',
            'eu-ES': 'Dinosauroak aurkitzen',
            'gl-ES': 'Descubrindo dinosaurios',
            'en-GB': 'Discovering dinosaurs'
        }
    },
    {
        id: 'bomberos',
        category: 'lugares_interes',
        icon: '🚒',
        color: '#E53935',
        title: {
            'es-ES': 'En el parque de bomberos',
            'ca-ES': 'Al parc de bombers',
            'eu-ES': 'Suhiltzaileen parkean',
            'gl-ES': 'No parque de bombeiros',
            'en-GB': 'At the fire station'
        },
        description: {
            'es-ES': 'Héroes valientes',
            'ca-ES': 'Herois valents',
            'eu-ES': 'Heroi kementsuak',
            'gl-ES': 'Heroes valentes',
            'en-GB': 'Brave heroes'
        }
    },
    {
        id: 'hospital',
        category: 'lugares_interes',
        icon: '🏥',
        color: '#81C784',
        title: {
            'es-ES': 'En el hospital',
            'ca-ES': 'A l\'hospital',
            'eu-ES': 'Ospitalean',
            'gl-ES': 'No hospital',
            'en-GB': 'At the hospital'
        },
        description: {
            'es-ES': 'Cuidando la salud',
            'ca-ES': 'Cuidant la salut',
            'eu-ES': 'Osasuna zainduz',
            'gl-ES': 'Coidando a saúde',
            'en-GB': 'Taking care of health'
        }
    },
    {
        id: 'castillo',
        category: 'lugares_interes',
        icon: '🏰',
        color: '#78909C',
        title: {
            'es-ES': 'Visitando un castillo',
            'ca-ES': 'Visitant un castell',
            'eu-ES': 'Gaztelua bisitatzen',
            'gl-ES': 'Visitando un castelo',
            'en-GB': 'Visiting a castle'
        },
        description: {
            'es-ES': 'Aventura medieval',
            'ca-ES': 'Aventura medieval',
            'eu-ES': 'Erdi Aroko abentura',
            'gl-ES': 'Aventura medieval',
            'en-GB': 'Medieval adventure'
        }
    }
];

// Utilidades para almacenamiento y batch generation
const CONTEXT_NAMES = CONTEXTS.map(c => c?.title?.['es-ES']);
const getContextById = (id) => CONTEXTS.find(c => c.id === id);

// Exportar para uso global y en app.js
window.CONTEXT_CATEGORIES = CONTEXT_CATEGORIES;
window.CONTEXTS = CONTEXTS;
if (typeof module !== 'undefined' && module.exports) {
    module.exports = { CONTEXTS, CONTEXT_CATEGORIES, CONTEXT_NAMES, getContextById };
}
